// Cleared for real products from database

// Keep the demo group functions but return empty arrays
export const generateDemoGroups = (userLocation) => {
  return [];
};

export const generateSimilarGroups = (baseGroup, userLocation) => {
  return [];
};

export const generateUserCreatedGroups = (userLocation) => {
  return [];
};

// Add missing functions that other components expect
export const initializeAllDemoData = () => {
  return {
    groups: [],
    users: [],
    skills: []
  };
};

export const getDemoUserDataWithSkills = () => {
  return {
    id: 'demo_user',
    name: 'Demo User',
    email: 'demo@uniledge.com',
    skills: [],
    stats: {
      totalSaved: 0,
      groupsJoined: 0,
      jobsCompleted: 0
    }
  };
};

// Default export for AdminContext
const generateDemoGroupsDefault = (userLocation) => {
  return [];
};

export default generateDemoGroupsDefault;
